import { useState, useEffect } from 'react'
import CheckIcon from 'src/static/icons/ico_check.svg'
import { SortOptions } from 'src/types/Main'
import { translateString } from '../../../../utils/translateString'

interface Props {
  filter: SortOptions;
  filteredSort: string;
  setFilteredSort(sort: string): void;
  filterOnClick: boolean;
}

const ListValue = (props: Props) => {
  const { filter, filteredSort, setFilteredSort } = props

  const [selected, setSelected] = useState(filter.value === filteredSort)

  const handlesFilter = async (value: string) => {
    if (selected) {
      setFilteredSort('')
    } else {
      setFilteredSort(value)
    }
    setSelected(!selected)
  }

  useEffect(() => {
    setSelected(filter.value === filteredSort)
  }, [filteredSort])

  return (
    <div
      className={`list-value-container ${
        selected ? 'label-selected' : ''
      }`}
      onClick={() => handlesFilter(filter.value)}
    >
      <div className="list-value-image">
        {selected && <img src={CheckIcon} />}
      </div>
      <div className="list-value-text">
        <span>{translateString(filter.title)}</span>
      </div>
    </div>
  )
}

export default ListValue
